// extracted by mini-css-extract-plugin
module.exports = {"container":"cc","block":"dc","subheading":"ec","cta":"fc","disabled":"gc","noBotMargin":"hc","light":"ic"};